import { render } from "./CompanyInfoIcon.vue?vue&type=template&id=1cde2fa4"
import script from "./CompanyInfoIcon.vue?vue&type=script&lang=js"
export * from "./CompanyInfoIcon.vue?vue&type=script&lang=js"
script.render = render

export default script